import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/store/modules/user'
import auth from '@/store/modules/auth'
import contact from '@/store/modules/contact'
import theme from '@/store/modules/theme'
import license from '@/store/modules/license'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    auth,
    contact,
    theme,
    license
  },
  state : {
    defaultPicture: '/avatar.png',
    message: null
  },
  mutations: {
    setMessage: (state, message) => state.message = message
  },
  actions: {
    successMessage({commit}, text) {
      commit('setMessage', {type: 'success', text})
    },
    errorMessage({commit}, text) {
      commit('setMessage', {type: 'error', text})
    }
  }
})
